<template>
 <a-modal
      title="选择服务商"
      width="40%"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :closable="false"
      :keyboard="false"
      :mask-closable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
     <div class="select_bar">
       <label>请选择服务商</label>
       <div class="select_case"><serviceSelect :value="selectCarrier" :is-default-select="true" @change="handleChange"></serviceSelect></div>
     </div>
    </a-modal>
</template>

<script>
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue'

  export default {
    name:'CarriersSelectDialog',
    components:{
      serviceSelect
    },
    data(){
      return {
        visible:false,
        confirmLoading:false,
        form:{},
        selectCarrier:''
      }

    },
    methods:{
      handleChange(value){
        this.form=value
      },
      init(value){
        this.selectCarrier=value
        this.visible=true
      },
      handleOk() {
        if(!this.form.customerCode){
          this.$message.warning('请选择服务商!')
          return
        }
        this.visible=false
        this.$emit('select',this.form)
      },
      handleCancel() {
         this.visible=false
        if(!this.selectCarrier){
          this.$router.go(-1)
        }
       
        
      },
    }
  }
</script>

<style lang="less" scoped>
.select_bar {
  display: flex;
  align-items: center;
  label{
    margin-right: 20px;
  }
  .select_case {
    flex: 1;
    min-width: 300px;
    max-width: 580px;
    /deep/.severs_select {
      min-width: 300px;
       max-width: 580px;
    }

  }
}

</style>